import * as React from 'react';
import { ClassNames } from '../../utils/classNames';
import { Icon, IconUtils } from '../icon';
/** Render a simple error with a message and an icon - mainly used for validation errors in form inputs */

export var ErrorMessage = React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      message = _ref.message,
      icon = _ref.icon;
  return React.createElement("div", {
    ref: ref,
    className: ClassNames.concat('arm-error-message', className)
  }, icon && React.createElement(Icon, {
    iconSet: icon.iconSet,
    icon: icon.icon
  }), " ", React.createElement("span", null, message));
});
ErrorMessage.defaultProps = {
  icon: IconUtils.getIconDefinition('Icomoon', 'warning')
};